import { useState, useEffect } from 'react';
import { Card, Badge } from 'react-bootstrap';
import '../styles/peopleCard.css';
import { BASE_URL } from '../constants';


const PeopleCard = ({
    display_name,
    groupImage = [],
    id,
    image = '',
    is_active = true,
    role = ''
}) => {

    const getInitials = () => {
        if (!display_name) return '?';
        return display_name
            .split(' ')
            .map(name => name[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    const imageUrl = image ? `${BASE_URL}images/people/${image}` : '';

    return (
        <Card className="people-card">
            <div className="image-container">
                {imageUrl ? (
                    <div className="profile-image">
                        <img
                            src={imageUrl}
                            alt={display_name}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentNode.classList.add('initials-fallback');
                                e.target.parentNode.innerHTML = `<span>${getInitials()}</span>`;
                            }}
                        />
                    </div>
                ) : (
                    <div className="initials-fallback">
                        <span>{getInitials()}</span>
                    </div>
                )}

                {groupImage && groupImage.length > 0 && (
                    <div className="group-images">
                        {groupImage
                            .filter(img => img !== "colivri.png") 
                            .map((img, index) => ( 
                                <div
                                    key={index}
                                    className="group-image-circle"
                                    style={{ zIndex: groupImage.length - index }}
                                >
                                    <img
                                        src={`${BASE_URL}images/groups/${img}`}
                                        alt="Group"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.parentNode.classList.add('group-fallback');
                                            e.target.parentNode.innerHTML = '?';
                                        }}
                                    />
                                </div>
                            ))}
                    </div>
                )}

                <div className="name-gradient">
                    <h5>{display_name}</h5>
                </div>
            </div>
            { role && (
                <Card.Body className="role-container">
                    <p>{role}</p>
                </Card.Body>
            )}
            
        </Card>
    );
}

export default PeopleCard;